



























































































import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import search from '@/store/modules/search';
import StartCompanyItem from '@/views/StartCompanyItem.vue';
import StartSieItem from '@/views/StartSieItem.vue';
import StartDocumentItem from '@/views/StartDocumentItem.vue';
import StartNewsItem from '@/views/StartNewsItem.vue';
import StartUpdatedItem from '@/views/StartUpdatedItem.vue';
import { EventItem, UpdatedCompany } from '@/store/models';
import { showWelcome, initialCompany } from '@/config';
import alert from '@/store/modules/alert';

@Component({
  components: {
    StartCompanyItem,
    StartSieItem,
    StartDocumentItem,
    StartNewsItem,
    StartUpdatedItem,
  },
})
export default class Start extends Vue {
  async mounted() {
    // console.log(user.companies);
    await search.setTerm('');
    await user.setActiveSie(null);
    await user.setSelectedSie(null);
    await user.setSelectedSieBlob(null);

    if (user.companies && user.companies.length === 0 && initialCompany) {
      await user.addCompany(initialCompany);
    }
  }
  openNews(name: string) {
    alert.setNews(name);
  }
  thisVersion() {
    if (process.env.VUE_APP_BRAND === 'GT') {
      return 'gt';
    }
  }
  get events(): EventItem[] | null {
    return user.events;
  }
  get updates(): UpdatedCompany[] | null {
    return user.updates;
  }
  get showWelcome() {
    return showWelcome;
  }
}
